<div class="confirm-dialog-header">
  <div class="icon-wrapper">
    <mat-icon color="warn" class="confirm-dialog-icon">warning</mat-icon>
  </div>
  <span class="confirm-dialog-title">{{ data.title || 'Confirm' }}</span>
</div>
<div class="confirm-dialog-content">
  <p>{{ data.message || 'Are you sure you want to proceed?' }}</p>
</div>
<div class="confirm-dialog-actions">
  <button mat-stroked-button color="primary" (click)="dialogRef.close(false)">Cancel</button>
  <button mat-flat-button color="warn" (click)="dialogRef.close(true)">Submit</button>
</div>